import { useTranslation } from "react-i18next";
import {Consts} from "../pages/consts";

const PgxHeader = ({ newPgx, setNewPgx, init = true, createNewDialogOpened= false }) => {
  const { t } = useTranslation();

  return (
    <form
      className={
        init
          ? "w3-container form-panel"
          : "w3-container w3-margin-bottom w3-left-align"
      }
    >
      <div className="w3-row w3-padding-small">
        <div className="w3-container w3-third">
          <label>
            {t("laboratory_name")}{ createNewDialogOpened ? '*:' : ':' }
          </label>
        </div>
        <div className="w3-container w3-twothird">
          {
            createNewDialogOpened
              ?
              <input
                name={Consts.LAB}
                type={Consts.TEXT}
                className="w3-input w3-border w3-round form-input"
                onChange={(event) =>
                  setNewPgx({ ...newPgx, labName: event.target.value })
                }
                defaultValue={newPgx?.labName}
              />
              :
              <label>{newPgx?.labName}</label>
          }
        </div>
      </div>
      <div className="w3-row w3-padding-small">
        <div className="w3-container w3-third">
          <label>
              {t("test_date")}{ createNewDialogOpened ? '*:' : ':' }
          </label>
        </div>
        <div className="w3-container w3-twothird">
          {
            createNewDialogOpened
              ?
              <input
                name="date"
                type="date"
                className="w3-input w3-border w3-round form-input"
                onChange={(event) =>
                  setNewPgx({ ...newPgx, testDate: event.target.value })
                }
                defaultValue={newPgx?.testDate}
              />
              :
              <label>{newPgx?.testDate}</label>
          }
        </div>
      </div>
    </form>
  );
};

export default PgxHeader;
